import { useState, useCallback } from 'react';
import API from 'api/api';

export default function useApprovePartner({ onSettled } = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const approvePartner = useCallback(
    async (partnerId) => {
      setLoading(true);
      setError(null);

      try {
        await API.put(`/users/${partnerId}/approve`);
        setLoading(false);
        if (onSettled) {
          onSettled();
        }
        return true;
      } catch (err) {
        setError(err);
        setLoading(false);
        if (onSettled) {
          onSettled();
        }
        return false;
      }
    },
    [onSettled],
  );

  return { approvePartner, loading, error };
}
